import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Button as ButtonComponent } from './Button';
export const Button = withComponentMeta(ButtonComponent, createBuiltInComponentMeta('Button'));
//# sourceMappingURL=index.js.map